/**
 * Transform chart data with category suffixes to aggregated format
 */
export const transformChartDataForExport = (
  chartData: Array<Record<string, any>>,
  options: { includeTotal?: boolean } = {}
): Array<Record<string, unknown>> => {
  const { includeTotal = true } = options;
  if (!chartData || !chartData.length) return [];

  const aggregatedRows: Array<Record<string, unknown>> = [];

  chartData.forEach((yearData) => {
    const year = (yearData as Record<string, any>).year;
    const keys = Object.keys(yearData);

    const categoryKeys = new Set<string>();
    keys.forEach((key) => {
      if (key.includes("__volume") || key.includes("__count")) {
        const category = key.replace(/__volume|__count/g, "");
        categoryKeys.add(category);
      }
    });

    categoryKeys.forEach((category) => {
      const volumeKey = `${category}__volume`;
      const countKey = `${category}__count`;
      const volume = (yearData as Record<string, any>)[volumeKey] || 0;
      const count = (yearData as Record<string, any>)[countKey] || 0;

      if (volume > 0 || count > 0) {
        const readableCategory = category
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");

        aggregatedRows.push({
          Year: year,
          Category: readableCategory,
          "Invested capital (CHF Mio)": volume,
          "Number of Deals": count,
        });
      }
    });

    if (
      includeTotal &&
      ((yearData as Record<string, any>).totalVolume > 0 ||
        (yearData as Record<string, any>).totalCount > 0)
    ) {
      aggregatedRows.push({
        Year: year,
        Category: "Total",
        "Invested capital (CHF Mio)": (yearData as Record<string, any>).totalVolume || 0,
        "Number of Deals": (yearData as Record<string, any>).totalCount || 0,
      });
    }
  });

  return aggregatedRows;
};

/**
 * Transform timeline data for export
 */
export const transformTimelineDataForExport = (
  chartData: Array<{ year: number; volume?: number; count?: number }>
) => {
  if (!chartData || !chartData.length) return [];

  return chartData.map((item) => ({
    Year: item.year,
    "Invested capital (CHF Mio)": item.volume || 0,
    "Number of Deals": item.count || 0,
  }));
};
